/**
 * Approved gameplay calibration from Prototype 01, Profile C.
 *
 * Scope: vehicle physics and dynamics only. Track layout, visuals, VFX and
 * audio values from the laboratory are intentionally not part of this file.
 */
export const APPROVED_PHYSICS_PROFILE = 'C' as const;

export const APPROVED_PHYSICS = {
  steering: {
    steerRate: 56,
    progressivity: 1.4,
    inertia: 65,
    grip: 0.68,
    recenter: 4.5,
    speedInstability: 0.6,
    speedInstabilityThreshold: 0.58,
    highSpeedSteerDropoff: 0.12,
    lowSpeedSteerMultiplier: 1.3,
    counterSteerBoost: 1.8,
  },
  banking: {
    rollResponse: 23,
    maxRollDegrees: 75,
    tiltSteerBoost: 2.5,
    bankTurnForce: 62,
    bankDrag: 5.5,
    strafeThrust: 195,
    quickStrafeImpulse: 55,
    rollReturnSpeed: 18,
  },
  drift: {
    yawBoost: 1.9,
    gripMultiplier: 0.18,
    brakeDeceleration: 3.5,
    slideTurnBoost: 1.6,
    threshold: 15,
    counterSteerAuthority: 1.6,
    entrySlipKick: 28,
    maxAngleDegrees: 65,
    angularDamping: 2.5,
  },
  propulsion: {
    topSpeed: 500,
    boostTopSpeed: 600,
    acceleration: 80,
    boostAcceleration: 125,
    boostDuration: 2.4,
    coastDeceleration: 4,
    brakeForce: 145,
    boostEnergyDrainRate: 4.5,
    passiveRegenRate: 6,
    boostCooldown: 0.3,
  },
  combat: {
    sideAttackForce: 500,
    sideAttackDuration: 0.31,
    sideAttackDamage: 32,
    spinAttackDuration: 0.5,
    spinAttackDamage: 52,
    spinAttackForce: 200,
    boostCost: 14,
    sideAttackCost: 3,
    spinAttackCost: 6,
    sideAttackReach: 4.2,
    spinAttackRadius: 4,
    sideAttackCooldown: 0.3,
    spinAttackCooldown: 0.6,
    bodySlamImpactMultiplier: 1.3,
  },
  hover: {
    height: 2.8,
    springStiffness: 250,
    springDamping: 50,
    wakeAmplitude: 0.12,
    wakeFrequency: 4.8,
    magneticGripStrength: 1.4,
  },
  flight: {
    pitchControlRate: 35,
    rollControlRate: 42,
    steerAuthority: 1.1,
    glideLift: 40,
    glideDrag: 5,
    diveAcceleration: 55,
    diveMaxSpeed: 85,
    airborneGravity: 90,
    airborneThreshold: 0.5,
    landingBoostEfficiency: 0.9,
    landingBoostMax: 140,
    landingImpactThreshold: 0.5,
    landingPenaltyDamage: 5,
    landingPenaltyDeceleration: 15,
    airStrafeThrust: 110,
  },
  ai: {
    baseSpeed: 350,
    aggressiveness: 1.8,
    rubberbanding: 1.8,
    laneChangeSpeed: 1.7,
    topSpeedCap: 550,
    boostFrequency: 0.6,
    boostTopSpeed: 550,
    boostAcceleration: 140,
    corneringGrip: 1.3,
    brakingTendency: 0.3,
    catchupAcceleration: 65,
  },
  camera: {
    distance: 15,
    height: 7.8,
    fovFactor: 0.78,
    speedFov: 0.1,
    lag: 14,
    lookahead: 38,
    shakeDecay: 1.7,
    rollFollow: 0.5,
    boostFovPulse: 0.12,
    driftSwing: 0.6,
  },
} as const;
